import { Box, Typography } from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';

type Props = {
  data: { date: string; revenue: number }[];
};

const formatCurrency = (value: number) =>
  new Intl.NumberFormat('ko-KR', {
    style: 'currency',
    currency: 'KRW',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

export default function NaverDailyRevenueChart({ data }: Props) {
  const chartData = [...data].sort((a, b) => a.date.localeCompare(b.date));

  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        backgroundColor: '#ffffff',
        borderRadius: 2,
        p: 3,
        mt: 3,
      }}
    >
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, textAlign: 'center' }}>
        일별 매출 추이
      </Typography>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="naverRevenueGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0044D2" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#0044D2" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="date"
            tickFormatter={(value: string) => {
              const date = new Date(value);
              return `${date.getMonth() + 1}/${date.getDate()}`;
            }}
          />
          <YAxis tickFormatter={(value: number) => `${(value / 1000).toFixed(0)}K`} />
          <RechartsTooltip
            formatter={(value: number) => [formatCurrency(value), '매출']}
            labelFormatter={(value: string) => new Date(value).toLocaleDateString('ko-KR')}
          />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="#0044D2"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#naverRevenueGradient)"
            dot={false}
            activeDot={{ r: 4 }}
            name="매출"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}
